module.exports = __webpack_public_path__ + "static/error-inline-example-797229c78cf179cc05f92a165d76c1ad.svg";